// DOM Ready event handlers and initialization
window.initializeTheme = function initializeTheme(switchToTabFunction, FeatureManagerClass, initializeRSVPFormBuilderFunction) {
    // Initialize modals
    setupThemeInfoModal();
    setupEditModal();

    // Initialize description truncation
    setupDescriptionTruncation();

    // Initialize form handlers
    setupFormHandlers(switchToTabFunction);

    // Initialize payment handlers
    setupPaymentHandlers();

    // Initialize gift registry handlers
    setupGiftRegistryHandlers();

    // Initialize event schedule handlers
    if (typeof setupScheduleHandlers === 'function') setupScheduleHandlers();

    // Initialize Section Manager
    if (typeof SectionManager === 'function') {
        window.sectionManager = new SectionManager();
    }

    // Initialize Feature Manager after a short delay to ensure all elements are ready
    setTimeout(() => {
        if (FeatureManagerClass) {
            window.featureManager = new FeatureManagerClass();
        }
        if (initializeRSVPFormBuilderFunction) {
            initializeRSVPFormBuilderFunction();
        }
    }, 100);

    // Check if user just logged in and restore form data from session
    setTimeout(() => {
        if (typeof window.restoreFormDataAfterLogin === 'function') {
            window.restoreFormDataAfterLogin();
        }
    }, 300);
}

// Make getCookie globally available
window.getCookie = function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// For ES6 module compatibility
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        initializeTheme: window.initializeTheme,
        getCookie: window.getCookie
    };
}

// For AMD module compatibility
if (typeof define === 'function' && define.amd) {
    define([], function () {
        return {
            initializeTheme: window.initializeTheme,
            getCookie: window.getCookie
        };
    });
}

// Theme.js - Clean version with module imports
// This version loads all modularized functionality without duplicates

// Mobile Utils - Initialize immediately (prevent pinch-zoom on mobile devices)
document.addEventListener('gesturestart', function (e) { e.preventDefault(); });
document.addEventListener('gesturechange', function (e) { e.preventDefault(); });
document.addEventListener('gestureend', function (e) { e.preventDefault(); });

// Initialize everything when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
    // console.log('=== Create Invite Script Loaded ===');
    // Initialize Bootstrap tooltips (delayed to ensure all elements are rendered)
    setTimeout(function () {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            var delayAttr = tooltipTriggerEl.getAttribute('data-bs-delay');
            var delay = delayAttr ? JSON.parse(delayAttr) : { show: 700, hide: 100 };
            var tooltipInstance = new bootstrap.Tooltip(tooltipTriggerEl, { delay: delay, trigger: 'hover' });
            // Hide tooltip immediately on click so it doesn't linger after the action
            tooltipTriggerEl.addEventListener('click', function () {
                tooltipInstance.hide();
            });
            return tooltipInstance;
        });
    }, 300);

    // Fix Bootstrap tooltips getting stuck on mobile touch devices.
    // On mobile there is no reliable mouseleave/blur after a tap, so
    // tooltips never auto-dismiss. We handle this in two ways:
    //   1. Any touchstart on the document hides every open tooltip.
    //   2. When a tooltip is shown on a touch device, auto-hide it
    //      after a short delay so it never gets permanently stuck.
    (function () {
        var _autoHideTimer = null;

        function hideAllTooltips() {
            document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
                var tt = bootstrap.Tooltip.getInstance(el);
                if (tt) tt.hide();
            });
        }

        document.addEventListener('touchstart', function () {
            hideAllTooltips();
        }, { passive: true });

        document.addEventListener('shown.bs.tooltip', function (e) {
            // Only auto-dismiss on touch-primary devices
            if (!window.matchMedia('(hover: none)').matches) return;
            clearTimeout(_autoHideTimer);
            var tt = bootstrap.Tooltip.getInstance(e.target);
            if (tt) {
                _autoHideTimer = setTimeout(function () { tt.hide(); }, 1500);
            }
        });
    })();

    // =============================
    // Country Currency Set Code
    // =============================
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Country select dropdowns — expose globally so onchange="handleCountryChange(this)" works on pages without _header.html
    window.handleCountryChange = function (select) {
        var country = select.value;
        var flagCode = country === 'UK' ? 'GB' : country;
        var flagUrl = 'https://purecatamphetamine.github.io/country-flag-icons/3x2/' + flagCode + '.svg';
        document.querySelectorAll('.country-flag-img').forEach(function (img) { img.src = flagUrl; });
        setCookie('country', country, 30);
        location.reload();
    };

    // ...existing code...
    const resizeBtn = document.getElementById('resizeBtn');
    const shareBtn = document.getElementById('shareBtn');
    const editBtn = document.getElementById('editBtn');
    const themeIframe = document.getElementById('theme-iframe');
    const mainContainer = document.getElementById('mainContainer');
    const modelContainer = document.getElementById('modelContainer');
    const bodyBackgroundColor = document.body.getAttribute('data-background-color');

    let isExpanded = mainContainer.classList.contains('expanded');

    // ============================================
    // HANDLE EXPAND/CONTRACT FUNCTIONALITY
    // ============================================
    if (resizeBtn) {
        resizeBtn.addEventListener('click', function () {
            isExpanded = !isExpanded;
            if (isExpanded) {
                mainContainer.classList.add('expanded');
                resizeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minimize-icon lucide-minimize"><path d="M8 3v3a2 2 0 0 1-2 2H3"/><path d="M21 8h-3a2 2 0 0 1-2-2V3"/><path d="M3 16h3a2 2 0 0 1 2 2v3"/><path d="M16 21v-3a2 2 0 0 1 2-2h3"/></svg>';
                // Change body background color !important
                document.body.style.backgroundColor = bodyBackgroundColor;

                // In fullscreen: hide share button, show edit button
                if (shareBtn) shareBtn.style.display = 'none';
            } else {
                mainContainer.classList.remove('expanded');
                resizeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-maximize-icon lucide-maximize"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';
                // Change body background color !important
                document.body.style.backgroundColor = '#ffffff';

                // In normal mode: show share button, hide edit button
                if (shareBtn) shareBtn.style.display = 'flex';
            }
        });
    }

    // Handle iframe loading
    if (themeIframe) {
        const loader = document.getElementById('iframe-loader');

        themeIframe.addEventListener('load', function () {
            // Hide loader and show iframe
            if (loader) {
                loader.style.display = 'none';
            }
            themeIframe.style.opacity = '1';

            // After every iframe load/reload: push current form data into the iframe's
            // [data-key-uid] elements and re-send music state.
            // We retry up to 5 times with increasing delays because some themes run their
            // own JS after the load event and may not have rendered [data-key-uid] elements
            // into the DOM immediately.
            let _repopAttempt = 0;
            function repopulateIframe() {
                _repopAttempt++;

                if (window.formDataStorage) {
                    const currentData = window.formDataStorage.getStoredData();
                    window.formDataStorage.updateIframeData(currentData, currentData);
                }

                // Re-send background-music state
                if (typeof window.updateIframeMusic === 'function') {
                    window.updateIframeMusic();
                }

                // Keep retrying until the iframe has [data-key-uid] elements or we hit the cap
                if (_repopAttempt < 5) {
                    try {
                        const iDoc = themeIframe.contentDocument || themeIframe.contentWindow?.document;
                        const hasUidEls = iDoc && iDoc.querySelectorAll('[data-key-uid]').length > 0;
                        if (!hasUidEls) {
                            setTimeout(repopulateIframe, _repopAttempt * 300);
                            return;
                        }
                    } catch (e) { /* cross-origin — can't check, just stop */ }
                }
            }
            setTimeout(repopulateIframe, 300);
        });
    }

    // ── Like / Save buttons ──────────────────────────────────────────────────
    (function () {
        var actionBox = document.querySelector('.action-btn[data-like-url]');
        if (!actionBox) return;

        var likeUrl  = actionBox.getAttribute('data-like-url');
        var saveUrl  = actionBox.getAttribute('data-save-url');
        var isAuthed = actionBox.getAttribute('data-user-authenticated') === 'true';
        var loginUrl = actionBox.getAttribute('data-login-url');
        var csrfToken = (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] || '';

        function animateBtn(btn, animClass) {
            btn.classList.add(animClass);
            btn.addEventListener('animationend', function () {
                btn.classList.remove(animClass);
            }, { once: true });
        }

        function doToggleFetch(btn, url, activeKey, animClass) {
            var freshCsrf = (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] || '';
            btn.disabled = true;
            fetch(url, {
                method: 'POST',
                headers: { 'X-CSRFToken': freshCsrf, 'X-Requested-With': 'XMLHttpRequest' },
            })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var isActive = data[activeKey];
                btn.classList.toggle('active', isActive);
                animateBtn(btn, animClass);
            })
            .catch(function (e) { console.error('Toggle failed:', e); })
            .finally(function () { btn.disabled = false; });
        }

        function toggleAction(btn, url, activeKey, animClass) {
            if (!isAuthed && !window.userIsAuthenticated) {
                if (typeof window.requireAuth === 'function') {
                    var overlayMsg = document.getElementById('ppm-auth-subtitle');
                    if (overlayMsg) overlayMsg.textContent = 'Sign in to like or save this template.';
                    window.requireAuth(function () {
                        isAuthed = true;
                        doToggleFetch(btn, url, activeKey, animClass);
                    });
                } else {
                    window.location.href = loginUrl + '?next=' + encodeURIComponent(window.location.pathname);
                }
                return;
            }
            doToggleFetch(btn, url, activeKey, animClass);
        }

        var likeBtn = document.getElementById('likeBtn');
        var saveBtn = document.getElementById('saveBtn');

        if (likeBtn) {
            likeBtn.addEventListener('click', function () {
                toggleAction(likeBtn, likeUrl, 'liked', 'like-pop');
            });
        }
        if (saveBtn) {
            saveBtn.addEventListener('click', function () {
                toggleAction(saveBtn, saveUrl, 'saved', 'save-pop');
            });
        }
    })();

    // Handle edit button — switch sidebar to theme-information and open PPM on details
    if (editBtn) {
        editBtn.addEventListener('click', function (e) {
            e.stopPropagation();

            var needsContraction = isExpanded && resizeBtn;
            if (needsContraction) {
                resizeBtn.click();
            }

            setTimeout(function () {
                window.showModel('theme-information-tab');
                if (typeof window.openPPMWithAuth === 'function') {
                    window.openPPMWithAuth('details');
                }
            }, needsContraction ? 400 : 0);
        });
    }

    // ============================================
    // UNIFIED MODEL SHOW/HIDE FUNCTIONALITY
    // ============================================

    // Handle all data-target-model elements - make them clickable to switch models
    const targetModelElements = document.querySelectorAll('[data-target-model]');
    targetModelElements.forEach((elem) => {
        elem.addEventListener('click', function (e) {
            e.stopPropagation();
            const targetModel = elem.getAttribute('data-target-model');
            window.showModel(targetModel);
        });
    });

    // Tabs that require authentication to access
    const PROTECTED_TABS = [
        'details-tab', 'event-details-tab', 'schedule-tab', 'venue-tab',
        'features-tab', 'rsvp-tab', 'rsvp-custom-tab', 'payment-tab', 'final-tab'
    ];

    // Universal model show/hide function
    window.showModel = function showModel(modelName) {
        // console.log('Showing model:', modelName);

        if (!modelContainer) {
            console.error('Model container not found');
            return;
        }

        // If the user is not authenticated (login-tab exists in DOM) and they try
        // to navigate to a protected editing tab, intercept and show login-tab first.
        // Store the intended destination so we can resume after login if needed.
        const loginTabEl = modelContainer.querySelector('[data-model="login-tab"]');
        if (loginTabEl && PROTECTED_TABS.includes(modelName)) {
            // Remember where the user wanted to go (useful for post-login redirect)
            window._intendedModelAfterLogin = modelName;
            modelName = 'login-tab';
        }

        // Hide all models
        const allModels = modelContainer.querySelectorAll('[data-model]');
        allModels.forEach(model => {
            model.setAttribute('data-state', 'hide');
        });

        // Show target model
        const targetModel = modelContainer.querySelector(`[data-model="${modelName}"]`);
        if (targetModel) {
            targetModel.setAttribute('data-state', 'show');
            // console.log('Model shown:', modelName);

            // Meta Pixel — InitiateCheckout when user navigates to the checkout/payment tab
            if (modelName === 'payment-tab' && typeof fbq !== 'undefined') {
                fbq('track', 'InitiateCheckout');
            } else {
                let payPulishBtnBox = document.querySelector("#paymentPublishBtnBox");
                if (payPulishBtnBox) payPulishBtnBox.innerHTML = '';
            }

            // Attach event listeners to all clickable items in this model
            attachModelEventListeners(targetModel, modelName);

            // Animate model transition if available
            if (typeof window.animateModelTransition === 'function') {
                window.animateModelTransition(targetModel);
            }
        } else {
            console.error('Model not found:', modelName);
        }
    }

    // Attach event listeners to all clickable items in a model
    function attachModelEventListeners(model, modelName) {
        // console.log('Attaching event listeners for model:', modelName);

        // Share option items (for share-theme model)
        const shareItems = model.querySelectorAll('.share-option-item');
        if (shareItems.length > 0) {
            shareItems.forEach((item) => {
                if (!item.hasEventListener) {
                    item.addEventListener('click', function (e) {
                        e.stopPropagation();
                        const shareType = this.getAttribute('data-share-type');
                        // console.log('Share item clicked:', shareType);
                        handleShareAction(shareType);
                    });
                    item.hasEventListener = true;
                }
            });
        }
    }

    // Handle share action
    function handleShareAction(type) {
        const currentUrl = window.location.href;
        const title = document.title || 'Check this out!';
        const text = 'Check out this amazing invitation template!';

        // console.log('Handling share:', type);

        switch (type) {
            case 'copy':
                navigator.clipboard.writeText(currentUrl).then(() => {
                    showNotification('Link copied to clipboard!', 'success');
                }).catch(() => {
                    showNotification('Failed to copy link', 'error');
                });
                break;

            case 'facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`, '_blank', 'width=600,height=400');
                break;

            case 'twitter':
                window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(text)}`, '_blank', 'width=600,height=400');
                break;

            case 'whatsapp':
                window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + currentUrl)}`, '_blank');
                break;

            case 'email':
                window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + '\n\n' + currentUrl)}`;
                break;

            case 'linkedin':
                window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`, '_blank', 'width=600,height=400');
                break;

            case 'threads':
                window.open(`https://threads.net/intent/post?text=${encodeURIComponent(text)}&url=${encodeURIComponent(currentUrl)}`, '_blank', 'width=600,height=400');
                break;

            case 'messages':
                window.location.href = `sms:?body=${encodeURIComponent(text + ' ' + currentUrl)}`;
                break;

            case 'more':
                if (navigator.share) {
                    navigator.share({
                        title: title,
                        text: text,
                        url: currentUrl
                    }).catch(console.error);
                } else {
                    showNotification('Web Share API not supported on this device', 'error');
                }
                // Don't close modal immediately for native share as it takes focus away
                return;
        }

        // Close model after sharing (except for 'more' which is handled above)
        setTimeout(() => {
            window.showModel('share-theme-tab');
        }, 300);
    }

    // Show notification
    function showNotification(message, type = 'success') {
        const notification = document.createElement('div');
        notification.textContent = message;
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: ${type === 'success' ? '#4CAF50' : '#f44336'};
            color: white;
            padding: 12px 24px;
            border-radius: 4px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            z-index: 9999;
        `;

        document.body.appendChild(notification);

        setTimeout(() => {
            notification.remove();
        }, 3000);
    }

    // Toggle card open/close state
    function toggleCard(element) {
        // If element is a string (ID), get the element
        if (typeof element === 'string') {
            const card = document.getElementById(element);
            if (card) {
                card.setAttribute('data-toggle-state', card.getAttribute('data-toggle-state') === 'open' ? 'closed' : 'open');
            }
            return;
        }

        // Otherwise, element is the clicked DOM element
        // Get the card ID from data-toggle-id attribute
        const cardId = element.getAttribute('data-toggle-id');
        if (cardId) {
            const card = document.getElementById(cardId);
            if (card) {
                card.setAttribute('data-toggle-state', card.getAttribute('data-toggle-state') === 'open' ? 'closed' : 'open');
            }
        }
    }

    // Make toggleCard globally available
    window.toggleCard = toggleCard;

    // Toggle element visibility based on data-toggle-elem-key
    function initializeToggleElements() {
        const toggleInputs = document.querySelectorAll('[data-toggle-elem-key]');

        toggleInputs.forEach(input => {
            const toggleKey = input.getAttribute('data-toggle-elem-key');
            const isReverse = input.getAttribute('data-toggle-reverse') === 'true';

            // Function to update element states
            const updateElementStates = () => {
                const targetElements = document.querySelectorAll(`[data-toggle-elem="${toggleKey}"]`);
                const isChecked = input.checked;

                // Determine the state based on checkbox and reverse flag
                const shouldShow = isReverse ? !isChecked : isChecked;

                targetElements.forEach(element => {
                    if (shouldShow) {
                        element.setAttribute('data-toggle-elem-state', 'block');
                    } else {
                        element.setAttribute('data-toggle-elem-state', 'hidden');
                    }
                });
            };

            // Initialize state on page load
            updateElementStates();

            // Add event listener for changes
            input.addEventListener('change', updateElementStates);
        });
    }

    // Initialize toggle elements
    initializeToggleElements();

    // Escape key handler
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            window.showModel('theme-information-tab');

            if (isExpanded && resizeBtn) {
                resizeBtn.click();
            }
        }
    });

    // Initialize all components in the correct order with a small delay to ensure modules are loaded
    setTimeout(() => {
        // Initialize modals
        if (typeof setupThemeInfoModal === 'function') setupThemeInfoModal();
        if (typeof setupEditModal === 'function') setupEditModal();

        // Initialize description truncation
        if (typeof setupDescriptionTruncation === 'function') setupDescriptionTruncation();

        // Initialize form handlers (pass switchToTab function if available)
        if (typeof setupFormHandlers === 'function' && typeof switchToTab === 'function') {
            setupFormHandlers(switchToTab);
        }

        // Initialize payment handlers
        if (typeof setupPaymentHandlers === 'function') setupPaymentHandlers();

        // Initialize gift registry handlers
        if (typeof setupGiftRegistryHandlers === 'function') setupGiftRegistryHandlers();

        // Initialize event schedule handlers
        if (typeof setupScheduleHandlers === 'function') setupScheduleHandlers();

        // Initialize background music handlers
        if (typeof initializeBackgroundMusicHandlers === 'function') initializeBackgroundMusicHandlers();

        // Initialize Section Manager
        if (typeof SectionManager === 'function') {
            window.sectionManager = new SectionManager();
        }

        // Initialize Feature Manager
        if (typeof FeatureManager === 'function') {
            window.featureManager = new FeatureManager();
        }

        // Initialize RSVP Form Builder
        if (typeof initializeRSVPFormBuilder === 'function') {
            initializeRSVPFormBuilder();
        }

        // Initialize Background Music Handlers
        if (typeof initializeBackgroundMusicHandlers === 'function') {
            initializeBackgroundMusicHandlers();
        }

        // Initialize feature card GSAP border animations
        if (typeof window.initFeatureCardBorder === 'function') {
            window.initFeatureCardBorder();
        }
    }, 100);

    // console.log('=== Script Initialization Complete ===');
});


(function () {
    function _populatePPMCustomTextFields() {
        var container = document.getElementById('ppmCustomTextFieldsContainer');
        if (!container) return;
        var fields = Array.isArray(window.themeDataFields) ? window.themeDataFields : [];
        var textFields = fields.filter(function (f) {
            return f.page_type === 'invitation' &&
                f.field !== 'venue_name' && f.field !== 'venue_address' &&
                f.media_type !== 'image' && f.media_type !== 'video';
        });
        if (!textFields.length) {
            container.innerHTML = '<p class="text-muted small p-2">No custom text fields available for this theme.</p>';
            return;
        }
        var stored = (window.storedInvitationData && typeof window.storedInvitationData === 'object')
            ? window.storedInvitationData : {};
        var html = textFields.map(function (f) {
            var val = stored[f.field] !== undefined ? stored[f.field] : (f.default_value || '');
            var desc = f.description
                ? '<div class="input-info-text mt-1 pt-1">' + f.description + '</div>'
                : '';
            return '<div class="mb-3">' +
                '<div class="form-group mb-0">' +
                '<label for="ppm-ctf-' + f.uid + '" class="form-label mb-1">' + f.label + '</label>' +
                '<div class="icon-group-input">' +
                '<div class="input-icon"><i class="bi bi-fonts"></i></div>' +
                '<input type="text" class="form-control shadow-none" id="ppm-ctf-' + f.uid + '"' +
                ' data-theme-key="' + f.field + '"' +
                ' placeholder="' + (f.default_value || '') + '"' +
                ' value="' + val + '">' +
                '</div>' +
                '</div>' +
                desc +
                '</div>';
        }).join('');
        container.innerHTML = html;
        container.querySelectorAll('input[data-theme-key]').forEach(function (input) {
            input.addEventListener('input', function () {
                var key = this.getAttribute('data-theme-key');
                var update = {};
                update[key] = this.value;
                if (window._inviteApp && typeof window._inviteApp.saveFormData === 'function') {
                    window._inviteApp.saveFormData(update);
                } else if (typeof window.saveFormData === 'function') {
                    window.saveFormData(update);
                }
            });
        });
    }

    var _observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            if (m.type === 'attributes' && m.attributeName === 'data-ppm-state') {
                if (m.target.getAttribute('data-ppm-state') === 'show') {
                    _populatePPMCustomTextFields();
                }
            }
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        var box = document.querySelector('[data-ppm-tab="custom-text"]');
        if (box) _observer.observe(box, { attributes: true });
    });
})();


// ////////////////////////////// FAQ Accordion ////////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
    const faqWrapper = document.querySelector('.faq-wrapper');

    if (!faqWrapper) return;
    faqWrapper.addEventListener('click', (e) => {
        const trigger = e.target.closest('.faq-toggle');
        if (!trigger) return;

        const currentItem = trigger.parentElement;
        const isActive = currentItem.classList.contains('active');

        // Close all items
        document.querySelectorAll('.faq-item').forEach(item => {
            item.classList.remove('active');
            item.querySelector('.faq-toggle').setAttribute('aria-expanded', 'false');
        });

        // Toggle clicked item
        if (!isActive) {
            currentItem.classList.add('active');
            trigger.setAttribute('aria-expanded', 'true');
        }
    });
});
// //////////////////////////////////////////////////////////////////////////////////
